/**
 * Author(s) : Gurudharshan
 * Purpose : This component is used for background animation.
 */
import React from 'react';
import styles from './BackgroundAnimation.module.scss';
import bgAnimation from '../../assets/video/bgAnimation.mp4';

function BackgroundAnimation(props) {
  return (
    <div
      className={`${styles.videoBg} ${
        props.theme === 'light' && styles.lightBg
      }`}>
      <video autoPlay loop muted playsInline>
        <source
          src={bgAnimation}
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>
    </div>
  );
}

export default React.memo(BackgroundAnimation);
